import { Button, Stack, SxProps } from '@mui/material';
import { FC, RefObject } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { WalletProfileAuthHint } from './wallet-profile-auth-hint';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state';
import ImageBoxFuture from '@/components/shared/image-box-future';

const EmptyTransactionsIcon = '/icons/profile/Empty-transactions.svg';

interface WalletNotCompletedProfileInfoProps {
  myWalletRef: RefObject<HTMLDivElement>;
  accordionSx: SxProps;
}

export const CashbackNotCompletedProfileInfo: FC<WalletNotCompletedProfileInfoProps> = ({
  myWalletRef,
  accordionSx,
}) => {
  const intl = useIntl();

  const setDialog = useDialog(s => s.setDialog, shallow);

  const handleCompleteProfileClick = () => {
    setDialog({
      wrapper: true,
      isCompleteProfileForm: true,
    });
  };

  return (
    <Stack
      ref={myWalletRef}
      sx={{
        ...accordionSx,
        alignItems: 'center',
        paddingX: {
          mobile: '16px',
          tablet: '16px',
        },
        paddingY: {
          mobile: '16px',
          tablet: pxToRem(34),
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '606px',
        }}
      >
        <ImageBoxFuture
          img={EmptyTransactionsIcon}
          title={intl.formatMessage({
            id: 'alt.cashback',
          })}
          objectFit='contain'
          sx={{
            width: {
              mobile: '168px',
              tablet: pxToRem(180),
            },
            height: {
              mobile: '132px',
              tablet: pxToRem(140),
            },
            marginBottom: {
              mobile: '26px',
              tablet: pxToRem(32),
            },
            alignSelf: 'center',
          }}
        />

        <Stack
          component='p'
          sx={{
            marginBottom: {
              mobile: '24px',
              tablet: pxToRem(29),
            },
          }}
        >
          <WalletProfileAuthHint
            message={intl.formatMessage(
              { id: 'wallet.user_not_completed_profile.profile' },
              { br: <br /> }
            )}
          />
        </Stack>
        <Stack
          direction='row'
          sx={{
            justifyContent: 'center',
          }}
        >
          <Button
            variant='contained'
            sx={{
              fontSize: '16px',
              flexBasis: '404px',
            }}
            onClick={handleCompleteProfileClick}
          >
            <FormattedMessage id='wallet.complete_your_profile' />
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
